const doValidations = (validations, setValid, handleValidation) => {
	const invalidArray = [];		
	const validIteration = validations.map((v) => {
		const isValid = v.valid();
		if (!isValid && !invalidArray.includes(v.id)) {
			invalidArray.push(v.id);
			handleValidation(v.id, isValid, v.text);
		}
		if (isValid && !invalidArray.includes(v.id)) {
			handleValidation(v.id, isValid, '');
		}
		return isValid;
	});
	const isAllValid = validIteration.filter((v) => v).length === validations.length;
	setValid(isAllValid);
};

export default doValidations;